import {
  Box,
  Button,
  Collapse,
  Dialog,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import useCustomConfirmSnackBar from "src/components/CustomComponents/useCustomConfirmSnackBar";
import {
  deleteAirlineFileApi,
  bulkPriceFileApi,
  bulkUpdateDateFileApi,
} from "src/Api/Services/AirlineUploadExcelApi";
import { useSnackbar } from "notistack5";
import useLoadingSnackbar from "src/components/CustomComponents/useLoadingSnackbar";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
const AirlineUploadExcelTable = ({
  fileData,
  editClick,
  fetchData,
  page,
  nextPage,
}) => {
  const { data, totalRecords, currentPage } = fileData;
  const { enqueueSnackbar } = useSnackbar();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState("");
  const showConfirmAlert = useCustomConfirmSnackBar();
  const { showLoadSnackbar, closeLoading, loading } = useLoadingSnackbar();
  const [price, setPrice] = useState(null);
  const [replaceDate, setReplaceDate] = useState({
    depDate: null,
    retDate: null,
  });
  const [value, setValue] = useState(null);
  const { depDate, retDate } = replaceDate;
  const handleDelete = async (id) => {
    if (loading) return;
    showLoadSnackbar("Please wait...");
    try {
      const { data } = await deleteAirlineFileApi(id);
      if (data.status) {
        fetchData();
      }
      enqueueSnackbar(data.message, {
        variant: data.status ? "success" : "error",
      });
      closeLoading();
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };
  const handleBulkPrice = async (id) => {
    if (!price) return;
    try {
      const { data } = await bulkPriceFileApi(price);
      if (data.status) {
        fetchData();
        setPrice("");
      }
      enqueueSnackbar(data.message, {
        variant: data.status ? "success" : "error",
      });
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };
  const handleBulkDateUpdate = async (date, type) => {
    try {
      const { data } = await bulkUpdateDateFileApi(date, type);
      if (data.status) {
        fetchData();
        setReplaceDate({ depDate: null, retDate: null });
      }
      enqueueSnackbar(data.message, {
        variant: data.status ? "success" : "error",
      });
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };
  return (
    <>
      <TableContainer
        className="tableairp-responsive"
        style={{ maxHeight: "none", height: "100%", marginTop: "20px" }}
      >
        <Table
          className="table-airp"
          sx={{ minWidth: 650 }}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow className="laststick-trr">
              {TableHeaderName.map((item, index) => (
                <TableCell
                  key={index}
                  style={{
                    ...([9].includes(index) && { minWidth: "250px" }),
                  }}
                >
                  {![5, 6].includes(index) && item}
                  {index === 5 && (
                    <div className="d-flex align-items-center">
                      <p className="mb-0">{item}</p>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={depDate}
                          onChange={(newValue) => {
                            const value = newValue.format("YYYY-MM-DD");
                            setReplaceDate({ ...replaceDate, depDate: value });
                            showConfirmAlert(
                              `Are you sure you want to replace Departure date ${value}?`,
                              "warning",
                              () => {
                                handleBulkDateUpdate(value, "departDate");
                              },
                              () =>
                                setReplaceDate({
                                  ...replaceDate,
                                  depDate: null,
                                }),
                            );
                          }}
                          renderInput={(params) => (
                            <TextField {...params} sx={inputStyle} />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  )}
                  {index === 6 && (
                    <div className="d-flex align-items-center">
                      <p className="mb-0">{item}</p>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={retDate}
                          onChange={(newValue) => {
                            const value = newValue.format("YYYY-MM-DD");
                            setReplaceDate({ ...replaceDate, retDate: value });
                            showConfirmAlert(
                              `Are you sure you want to replace Return date ${value}?`,
                              "warning",
                              () => {
                                handleBulkDateUpdate(value, "returnDate");
                              },
                              () =>
                                setReplaceDate({
                                  ...replaceDate,
                                  retDate: null,
                                }),
                            );
                          }}
                          renderInput={(params) => (
                            <TextField {...params} sx={inputStyle} />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  )}
                  {index === 9 && (
                    <>
                      {/* <p>Replace</p> */}
                      <input
                        type="number"
                        value={price}
                        defaultValue={price}
                        onChange={(e) => setPrice(e.target.value.trim())}
                        className="w-1/4 border mx-2 p-1"
                        placeholder="0"
                      />
                      <Button
                        className="ml-2 p-1"
                        variant="contained"
                        onClick={() =>
                          price &&
                          showConfirmAlert(
                            `Are you sure you want to replace price by ${price} ?`,
                            "warning",
                            () => {
                              handleBulkPrice();
                            },
                            () => setPrice(""),
                          )
                        }
                      >
                        Ok
                      </Button>
                    </>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((item, index) => (
              <>
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.searchKey}</TableCell>
                  <TableCell>{item.tripType}</TableCell>
                  <TableCell>{item.origin}</TableCell>
                  <TableCell>{item.destination}</TableCell>
                  <TableCell>{item.departureDate}</TableCell>
                  <TableCell>{item.returnDate}</TableCell>
                  <TableCell>
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() =>
                        setOpen(item.searchKey === open ? "" : item.searchKey)
                      }
                    >
                      {open === item.searchKey ? (
                        <KeyboardArrowUpIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => setOpen(open ? "" : item.searchKey)}
                    >
                      {open === item.searchKey ? (
                        <KeyboardArrowUpIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell>{item.totalPrice}</TableCell>
                  <TableCell>{item.currency}</TableCell>
                  <TableCell>
                    <div className="d-flex">
                      <div className="me-2">
                        <IconButton
                          aria-label="edit"
                          color="success"
                          onClick={() => editClick(item)}
                        >
                          <EditIcon />
                        </IconButton>
                      </div>
                      <div>
                        {" "}
                        <IconButton
                          aria-label="delete"
                          color="error"
                          disabled={loading}
                          onClick={() =>
                            showConfirmAlert("Are you sure?", "warning", () =>
                              handleDelete(item._id),
                            )
                          }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={10}
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                  >
                    <Collapse
                      in={item.searchKey === open}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box margin={2}>
                        {/* Outbound Table */}
                        {item?.outbound?.length > 0 && (
                          <h4 className=" text-sm font-bold">Outbound</h4>
                        )}
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              {item?.outbound?.length > 0 &&
                                Object.keys(item?.outbound[0]).map((key, i) => (
                                  <TableCell key={i}>{key}</TableCell>
                                ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {item?.outbound?.length > 0 &&
                              item?.outbound?.map((val, i) => (
                                <TableRow key={i}>
                                  {Object.values(val).map((val, i) => (
                                    <TableCell key={i}>{val}</TableCell>
                                  ))}
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>

                        {/* Inbound Table */}
                        {item?.inbound?.length > 0 && (
                          <h4
                            style={{ marginTop: "20px" }}
                            className=" text-sm font-bold"
                          >
                            Inbound
                          </h4>
                        )}
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              {item?.inbound?.length > 0 &&
                                Object.keys(item?.inbound[0]).map((key, i) => (
                                  <TableCell key={i}>{key}</TableCell>
                                ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {item?.inbound?.length > 0 &&
                              item?.inbound?.map((val, i) => (
                                <TableRow key={i}>
                                  {Object.values(val).map((val, i) => (
                                    <TableCell key={i}>{val}</TableCell>
                                  ))}
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={totalRecords}
          rowsPerPage={rowsPerPage}
          page={page - 1}
          onPageChange={(e, page) => {
            nextPage(page + 1);
          }}
          // onRowsPerPageChange={(e) => {
          //   setRowsPerPage(+e.target.value);
          //   // setPage(0);
          // }}
        />
      </TableContainer>
    </>
  );
};

export default AirlineUploadExcelTable;

const TableHeaderName = [
  "S.No.",
  "SearchKey",
  "Trip Type",
  "Origin",
  "Destination",
  "Departure Date",
  "Return Date",
  "Outbound",
  "Inbound",
  "Total Price",
  "Currency",
  "Action",
];
const inputStyle = {
  width: 170,
  marginLeft: "10px",
  "& .MuiOutlinedInput-input": {
    padding: "10.5px 14px",
    fontSize: "14px",
  },
};
